export const EVENT_NAMES = {
  // First login
  FIRST_LOGIN_START: "portal_first_login_start",
  FIRST_LOGIN_PASSWORD_OPENED: "portal_first_login_new_password_opened",
  FIRST_LOGIN_PASSWORD_SUCCESS: "portal_first_login_new_password_success",
  FIRST_LOGIN_SUCCESS: "portal_first_login_success",
  FIRST_LOGIN_DASHBOARD: "portal_user_landed_dashboard",

  // Forgot password
  FORGOT_PASSWORD_OPENED: "forgot_password_opened",
  FORGOT_PASSWORD_EMAIL_SUBMITTED: "forgot_password_email_submitted",
  FORGOT_PASSWORD_VERIFICATION_SENT: "forgot_password_verification_sent",
  FORGOT_PASSWORD_VERIFIED: "forgot_password_verified",
  FORGOT_PASSWORD_NEW_PASSWORD_OPENED: "forgot_password_new_password_opened",
  FORGOT_PASSWORD_RESET_SUCCESS: "forgot_password_reset_success",

  // Contact support
  CONTACT_SUPPORT: "contact_support",

  // Change password
  CHANGE_PASSWORD_OPENED: "change_password_opened",
  CHANGE_PASSWORD_EMAIL_SUBMITTED: "change_password_email_submitted",
  CHANGE_PASSWORD_EMAIL_SENT: "change_password_email_sent",
  CHANGE_PASSWORD_NEW_PASSWORD_OPENED: "change_password_new_password_opened",
  CHANGE_PASSWORD_RESET_SUCCESS: "change_password_reset_success",

  // Change email
  CHANGE_EMAIL_INITIATED: "change_email_initiated",
  CHANGE_EMAIL_VERIFICATION_SENT: "change_email_verification_sent",
  CHANGE_EMAIL_VERIFIED: "change_email_verified",
  CHANGE_EMAIL_SUCCESS: "change_email_success",
  CHANGE_EMAIL_FAIL: "change_email_fail",

  // Device deactivation
  DEVICE_DEACTIVATION_INITIATED: "device_deactivation_initiated",
  DEVICE_DEACTIVATION_CONFIRMED: "device_deactivation_confirmed",
  DEVICE_DEACTIVATION_SUCCESS: "device_deactivation_success",
  DEVICE_DEACTIVATION_CANCELLED: "device_deactivation_cancelled",
  DEVICE_DEACTIVATION_ERRORED: "device_deactivation_errored",

  // Installer download
  INSTALL_DOWNLOADED: "install_downloaded",

  // Invoice download
  INVOICE_DOWNLOADED: "invoice_downloaded",
  INVOICE_DOWNLOAD_SUCCESS: "invoice_downloaded_success",
  INVOICE_DOWNLOAD_FAILED: "invoice_downloaded_failed",

  // Screens viewed
  SCREEN_DASHBOARD_VIEWED: "screen_dashboard_viewed",
  SCREEN_ACCOUNT_VIEWED: "screen_account_viewed",
  SCREEN_DEVICES_VIEWED: "screen_devices_viewed",
  SCREEN_INVOICES_VIEWED: "screen_invoices_viewed",

  // Language change
  LANGUAGE_CHANGED: "language_changed",

  // Manage subscription
  SUBSCRIPTION_MANAGE_OPENED: "subscription_manage_opened",
  PAYMENT_METHOD_CLICKED: "Update_payment_method_clicked",
  PAYMENT_METHOD_CHOSE_METHOD: "Update_payment_method_chose_method",
  PAYMENT_METHOD_PROCESSOR_OPENED: "Update_payment_method_opened_processor",

  SUBSCRIPTION_MANAGE_STATUS: "sub_manage_status",
  SUBSCRIPTION_PAUSED_INITIATED: "sub_pause_initiated",
  SUBSCRIPTION_PAUSED_CONFIRMED: "sub_pause_confirmed",
  SUBSCRIPTION_PAUSED_FAILED: "sub_pause_failed",
  SUBSCRIPTION_PAUSED_SUCCESS: "sub_pause_success",
  SUBSCRIPTION_PAUSED_KEEP: "sub_pause_keep",

  SUBSCRIPTION_CANCELLED_INITIATED: "sub_cancel_initiated",
  SUBSCRIPTION_CANCELLED_DISCOUNT_OFFER: "sub_cancel_disc_offer",
  SUBSCRIPTION_CANCELLED_DISCOUNT_ACCEPTED: "sub_cancel_disc_accepted",
  SUBSCRIPTION_CANCELLED_DISCOUNT_DECLINED: "sub_cancel_disc_declined",
  SUBSCRIPTION_CANCELLED_EMAIL_SENT: "sub_cancel_email_sent",
  SUBSCRIPTION_CANCELLED_EMAIL_VERIFIED: "sub_cancel_email_verified",
  SUBSCRIPTION_CANCELLED_EMAIL_FAILED: "sub_cancel_email_failed",
  SUBSCRIPTION_CANCELLED_PAUSED_OFFER: "sub_cancel_paused_offer",
  SUBSCRIPTION_CANCELLED_PAUSED_ACCEPTED: "sub_cancel_paused_accepted",
  SUBSCRIPTION_CANCELLED_PAUSED_DECLINED: "sub_cancel_paused_declined",
  SUBSCRIPTION_CANCELLED_SUCCESS: "sub_cancel_success",
  SUBSCRIPTION_CANCELLED_FAILED: "sub_cancel_failed",

  SUR_SUBSCRIPTION_CANCELLED_INITIATED: "sur_sub_cancel_initiated",
  SUR_SUBSCRIPTION_CANCELLED_DISCOUNT_OFFER: "sur_sub_cancel_disc_offer",
  SUR_SUBSCRIPTION_CANCELLED_DISCOUNT_ACCEPTED: "sur_sub_cancel_disc_accepted",
  SUR_SUBSCRIPTION_CANCELLED_DISCOUNT_DECLINED: "sur_sub_cancel_disc_declined",
  SUR_SUBSCRIPTION_CANCELLED_EMAIL_SENT: "sur_sub_cancel_email_sent",
  SUR_SUBSCRIPTION_CANCELLED_EMAIL_VERIFIED: "sur_sub_cancel_email_verified",
  SUR_SUBSCRIPTION_CANCELLED_EMAIL_FAILED: "sur_sub_cancel_email_failed",
  SUR_SUBSCRIPTION_CANCELLED_PAUSED_OFFER: "sur_sub_cancel_paused_offer",
  SUR_SUBSCRIPTION_CANCELLED_PAUSED_ACCEPTED: "sur_sub_cancel_paused_accepted",
  SUR_SUBSCRIPTION_CANCELLED_PAUSED_DECLINED: "sur_sub_cancel_paused_declined",
  SUR_SUBSCRIPTION_CANCELLED_SUCCESS: "sur_sub_cancel_success",
  SUR_SUBSCRIPTION_CANCELLED_FAILED: "sur_sub_cancel_failed",
  SUBSCRIPTION_SUPPORT: "subscription_manage_status_support",
  SUBSCRIPTION_CANCELLED_KEEP: "sub_cancel_keep",

  LICENSE_KEYS_OPENED: "license_keys_opened",

  // Survey
  SURVEY_OPENED: "survey_opened",
  SURVEY_SUBMITTED: "survey_submitted",
  SURVEY_CANCELLED: "survey_cancelled",
  SURVEY_BACK: "survey_back",
} as const;
